
    import './styles.scoped.css';
    export default {
  "toggle-button": "awsui_toggle-button_16w0h_d0uo3_9",
  "close-button": "awsui_close-button_16w0h_d0uo3_44"
};
  